import React from 'react';

class WeatherBlock extends React.Component {
    render = () => <div>Custom Griffin WeatherBlock (SSR)</div>;
}

if (typeof window !== 'undefined') {
    WeatherBlock = require('./WeatherBlock_BrowserOnly');
}

export default WeatherBlock;


// WEBPACK FOOTER //
// ./app/components/custom/griffin/WeatherBlock.js